import { Injector } from "@angular/core";
import { AppConsts } from "@shared/AppConsts";
import { LocalizationService } from "@abp/localization/localization.service";
import { PermissionCheckerService } from "@abp/auth/permission-checker.service";
import { FeatureCheckerService } from "@abp/features/feature-checker.service";
import { NotifyService } from "@abp/notify/notify.service";
import { SettingService } from "@abp/settings/setting.service";
import { MessageService } from "@abp/message/message.service";
import { AbpMultiTenancyService } from "@abp/multi-tenancy/abp-multi-tenancy.service";
import { AppSessionService } from "@shared/common/session/app-session.service";
import { PrimengDatatableHelper } from "shared/helpers/PrimengDatatableHelper";
import { AppUiCustomizationService } from "@shared/common/ui/app-ui-customization.service";
import { AppUrlService } from "@shared/common/nav/app-url.service";
import {
    ViewChild
} from "@angular/core";
import * as moment from "moment";
import { PaymentChargesServiceProxy, ItauPaymentServiceProxy } from "@shared/service-proxies/service-proxies";
import { FileDownloadService } from "@shared/utils/file-download.service";
import { LoginService } from "account/login/login.service";
import { TicketInfoModalComponent } from "@app/financial/payment/modals/ticket-info-modal.component";

export abstract class AppComponentBase {

    localizationSourceName =
    AppConsts.localization.defaultLocalizationSourceName;

    localization: LocalizationService;
    loginService: LoginService;
    permission: PermissionCheckerService;
    feature: FeatureCheckerService;
    notify: NotifyService;
    setting: SettingService;
    message: MessageService;
    multiTenancy: AbpMultiTenancyService;
    appSession: AppSessionService;
    primengDatatableHelper: PrimengDatatableHelper;
    ui: AppUiCustomizationService;
    appUrlService: AppUrlService;
    externalAccessToken: string;

    paymentChargesService: PaymentChargesServiceProxy;
    itauPaymentServiceProxy: ItauPaymentServiceProxy;
    fileDownloadService: FileDownloadService;
    loading = false;

    constructor(injector: Injector) {


        this.localization = injector.get(LocalizationService);
        this.loginService = injector.get(LoginService);
        this.permission = injector.get(PermissionCheckerService);
        this.feature = injector.get(FeatureCheckerService);
        this.notify = injector.get(NotifyService);
        this.setting = injector.get(SettingService);
        this.message = injector.get(MessageService);
        this.multiTenancy = injector.get(AbpMultiTenancyService);
        this.appSession = injector.get(AppSessionService);
        this.ui = injector.get(AppUiCustomizationService);
        this.appUrlService = injector.get(AppUrlService);
        this.paymentChargesService = injector.get(PaymentChargesServiceProxy);
        this.itauPaymentServiceProxy = injector.get(ItauPaymentServiceProxy);
        this.fileDownloadService = injector.get(FileDownloadService);
        this.primengDatatableHelper = new PrimengDatatableHelper();


    }



    checkAccessByToken(): void{
        this.loginService.checkTokenAccess();
    }


    l(key: string, ...args: any[]): string {
        return this.ls(this.localizationSourceName, key, args);
    }

    ls(sourcename: string, key: string, ...args: any[]): string {
        let localizedText = this.localization.localize(key, sourcename);

        if (!localizedText) {
            localizedText = key;
        }

        if (!args || !args.length) {
            return localizedText;
        }

        args[0].unshift(localizedText);

        return abp.utils.formatString.apply(this, args[0]);
    }

    isGranted(permissionName: string): boolean {
        return this.permission.isGranted(permissionName);
    }

    isGrantedAny(...permissions: string[]): boolean {
        if (!permissions) {
            return false;
        }

        for (const permission of permissions) {
            if (this.isGranted(permission)) {
                return true;
            }
        }

        return false;
    }

    s(key: string): string {
        return abp.setting.get(key);
    }

    appRootUrl(): string {
        return this.appUrlService.appRootUrl;
    }

    formatSubscriptionDate(date: any): string {
        return !date ? "" : moment(date).format("L");
    }

    formatSubscriptionDateWithHours(date: any): string {
        return !date ? "" : moment(date).format("L LT");
    }

    addErrorTab(tab): string {
        return !!tab && !!tab.invalid && tab.touched ? "has-error-tab" : "";
    }

    isRMC(userName: string): boolean {
        return (
            userName == "admin" ||
            userName == "ADMIN" ||
            userName == "RMCBROTHERS" ||
            userName == "rmcbrothers"
        );
    }

    isIphone(): boolean {
        const ua = navigator.userAgent || navigator.vendor;
        return /iPhone/i.test(ua);
    }

    generateNumericArray(begin: number, end: number): number[] {
        let arr = [];

        for (var i = begin; i <= end; i++) {
            arr.push(i);
        }

        return arr;
    }

    compareByIdFn(obj1: any, obj2: any) {
        return !!obj1 && !!obj2 && obj1.id === obj2.id;
    }


    gotoNewSystem(userId: number, url?: string): void {

        this.loginService.getSharedAccessToken(userId).then((result) => {
           let newUrl = (url ? url : this.appUrlService.appNewSystemUrl) + '?token=' + result;
           window.open(newUrl, '_blank');
        });
    }

    gotoChangePassword(target?: 'admin' | 'member'): void {
        if (abp.session.userId) {
            this.loginService.getChangePasswordRedirectInfo().then((info) => {
                window.open(info.url + '?token=' + info.token, '_blank');
            });
            return;
        }

        const settingKey = target === 'admin'
            ? 'App.UserManagement.PortalAdminChangePasswordUrl'
            : 'App.UserManagement.PortalMemberChangePasswordUrl';
        const fallback = target === 'admin'
            ? 'https://portal.saesp.org.br/change-password'
            : 'https://portal.saesp.org.br/associate/password';
        const url = abp.setting.get(settingKey) || fallback;
        window.open(url, '_blank');
    }

getTicket(sendByEmail: boolean, record: any): Promise<any> {
  this.loading = true;

  return new Promise((resolve, reject) => {
    this.paymentChargesService
      .getTicket(sendByEmail, record.id)
      .finally(() => {
        this.loading = false;
      })
      .subscribe({
        next: (result) => {

          if (sendByEmail) {
            this.message.success(this.l("The ticket have been sent by email."));
          } else if (result.barcode) {
            this.notify.success(this.l("The ticket have been generated"));
          } else {
            const _win = window.open("", "SHOPLINE" + Date.now());

            if (!!_win) {
              _win.document.write(result.html);
            } else {
              this.message.warn(
                this.l(
                  "The pop‐ups is bloked. For generate the ticket is necessary enable pop‐ups in your navigator and try again."
                ),
                this.l("Warning!")
              );
            }
          }

          resolve(result);
        },
        error: (err) => reject(err), // ✅ trata erro corretamente
      });
  });
}


    copyToClipboard(text) {
        navigator['clipboard'].writeText(text);
        this.notify.success(this.l('CopiedSuccessfully'));
    }

    block(element) {
        mApp.block(element);
    }

    unBlock(element) {
        mApp.unblock(element);
    }
}



// WEBPACK FOOTER //
// ./src/shared/common/app-component-base.ts